import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { WorkflowStepper } from "./WorkflowStepper";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { useTranslation } from "react-i18next";
import { WorkflowService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { LoadingAnimation } from "../../../shared/components/Loading";
import { EmptyState } from "../../../shared/components/EmptyState";
import Select from "react-select";
import { IProductsList } from "../../products/dto/IProducts";
import { CustomImageHandler } from "../../../shared/components/CustomImageHandler";
import { formatDate } from "../../../shared/functions/Functions";
import { Pagination } from "../../../shared/paginations/Paginations";
const WorkflowStep8 = () => {
  const { id } = useParams();
  const [productsList, setProductsList] = useState<
    IProductsList[] | undefined
  >();
  const [checkedValues, setCheckedValues] = useState<number[]>([]);
  const workflowData = useSelector((state: IAllStates) => state.workflow);
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [workflowName, setWorkflowName] = useState("");
  const { exportFormatEnum, exportView, productExportSelection } = useSelector(
    (state: IAllStates) => state.enums
  );
  const perPageOptions = [
    {
      label: 10,
      value: 10,
    },
    {
      label: 50,
      value: 50,
    },
    {
      label: 100,
      value: 100,
    },
    {
      label: 500,
      value: 500,
    },
  ];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [formatChoice, setFormatChoice] = useState<string>("");
  const [viewChoice, setViewChoice] = useState<string>("");
  const [selectChoice, setSelectChoice] = useState<string>("");
  const arr4 = exportFormatEnum;
  const handleClose = () => {
    setShow(false);
  };
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
  });
  const handleOpen = () => {
    setShow(true);
  };
  const handlePerPage = (e: any) => {
    setPagination((prev) => ({ ...prev, page: 1, perPage: e.value }));
  };
  const checkAll = (e: any) => {
    if (e.target.checked) {
      const mapped = productsList?.map((product) => product.id);
      setCheckedValues(mapped as number[]);
    } else {
      setCheckedValues([]);
    }
  };
  const formatChangeHandler = (e: any) => {
    setFormatChoice(e.target.value);
  };

  const viewChangeHandler = (e: any) => {
    setViewChoice(e.target.value);
  };
  const checkboxHandler = (e: any) => {
    if (e.target.checked) {
      setCheckedValues((prev) => [...prev, +e.target.value]);
    } else {
      setCheckedValues((prev) =>
        prev.filter((value) => value !== +e.target.value)
      );
    }
  };
  const selectChangeHandler = (e: any) => {
    setSelectChoice(e.target.value);
  };
  const handleDownload = (file: any, name: string) => {
    const xhr = new XMLHttpRequest();
    const fileName = name;
    xhr.open("GET", file, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: "application/*" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? "";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 0);
      }
    };
    xhr.send();
  };
  const submitHandler = (e: any) => {
    e.preventDefault();
    WorkflowService.export(+id!, {
      format: formatChoice,
      view: viewChoice,
      select: selectChoice,
      products: selectChoice === "custom" ? checkedValues : [],
    })
      .then((res) => {
        const filePath = res?.path;
        const fileName = filePath?.split("/").pop();
        const fileExtension = fileName.split(".").pop();
        handleDownload(filePath, workflowName + "." + fileExtension);
      })
      .catch((err) => ErrorToast(err));
  };

  const completeHandler = () => {
    WorkflowService.workflowComplete(+id!)
      .then((res) => SuccessToast(t(`toasts.successfully_completed`)))
      .catch((err) => ErrorToast(err));
  };
  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  useEffect(() => {
    WorkflowService.getWorkflowExportProducts(pagination, Number(id))
      .then((response) => {
        const { data } = response;
        if (pagination?.page > 1 && pagination?.page > response?.totalPages) {
          setPage(response?.totalPages);
          setPagination({ ...pagination, page: response?.totalPages });
        }
        setProductsList(data as any);
        setPage(response?.page);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
      })
      .catch((error) => ErrorToast(error));
  }, [pagination, triggerUpdate]);
  useEffect(() => {
    Boolean(id) &&
      WorkflowService.getWorkflowById(id as any)
        .then((response: any) => {
          setWorkflowName(response?.name ?? "WorkflowWithoutName");
        })
        .catch((error) => ErrorToast(error));
  }, [id]);
  return (
    <Card>
      <Helmet>
        <title>
          {workflowData?.name ?? "-"} {t("workflow.EXPORT")}
        </title>
      </Helmet>
      <Card.Body>
        <WorkflowStepper id={id} step={"EXPORT"} />
        <div className="row ">
          <div className="col-4">
            <h5>{t("workflow.format")}:</h5>
            {arr4?.map((format: string, idx: number) => (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="format"
                  id={`flexRadioDefault${idx}`}
                  value={format}
                  onChange={formatChangeHandler}
                />
                <label className="form-check-label" htmlFor="format">
                  {format.toUpperCase()}
                </label>
              </div>
            ))}
          </div>
          <div className="col-4">
            <h5>{t("workflow.view")}:</h5>
            {exportView?.map((view: string, idx: number) => (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="view"
                  value={view}
                  id={`flexRadioDefault${idx}`}
                  onChange={viewChangeHandler}
                />
                <label className="form-check-label" htmlFor="view">
                  {t(`export_workflow.${view.toUpperCase()}`)}
                </label>
              </div>
            ))}
          </div>
          <div className="col-4">
            <h5>{t("global_v2.select_products")}:</h5>
            {productExportSelection?.map((select: string, idx: number) => (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="select"
                  value={select}
                  id={`flexRadioDefault${idx}`}
                  onChange={selectChangeHandler}
                />
                <label className="form-check-label" htmlFor="select">
                  {t(`export_workflow.${select.toUpperCase()}`)}
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex gap-3">
          <button
            className="btn btn-sm btn-secondary  d-flex align-items-center ms-auto "
            type="button"
            onClick={submitHandler}
            aria-expanded="false"
            disabled={
              (selectChoice === "custom" && checkedValues?.length === 0) ||
              viewChoice === "" ||
              formatChoice === "" ||
              selectChoice === ""
            }
          >
            {`${t("global.export")}`}
          </button>{" "}
          <button
            className="btn btn-sm btn-secondary  d-flex align-items-center "
            type="button"
            onClick={handleOpen}
            aria-expanded="false"
          >
            {`${t("global.complete")}`}
          </button>
        </div>
        {selectChoice === "custom" && (
          <div className="row">
            {productsList == undefined ? (
              <LoadingAnimation />
            ) : productsList.length === 0 ? (
              <EmptyState />
            ) : (
              <div className="table-responsive">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <h6 className="m-0 p-0 ">{t("workflow.per_page")}:</h6>
                  <Select
                    className="react-select-field"
                    onChange={handlePerPage}
                    placeholder={`${t("workflow.per_page")}:`}
                    options={perPageOptions}
                    defaultValue={perPageOptions[0]}
                  />
                </div>
                <Table className="align-middle table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">
                        <input
                          className="form-check-input m-0 cursor-pointer"
                          // value={maxId}
                          checked={
                            checkedValues.length === productsList?.length
                          }
                          type="checkbox"
                          onChange={checkAll}
                        />
                      </th>
                      <th scope="col">{`${t("global.id")}`}</th>
                      <th scope="col">{`${t("global.aenCode")}`}</th>
                      <th scope="col">{`${t("products.product")}`}</th>
                      <th scope="col">{`${t("products.category")}`}</th>
                      <th scope="col">{`${t("products.createdAt")}`}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productsList?.map((product: any) => (
                      <tr key={product?.id}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input m-0 cursor-pointer"
                            onChange={(e) => checkboxHandler(e)}
                            value={product?.id}
                            checked={checkedValues?.includes(
                              Number(product?.id)
                            )}
                          />
                        </td>
                        <td>{product.id}</td>
                        <td>{product.eanCode ?? "-"}</td>
                        <td>
                          <span className="d-flex justify-content-start">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 me-3">
                                <div className="avatar-sm bg-light rounded p-1">
                                  <CustomImageHandler
                                    path={product?.productPictures?.[0]?.path}
                                    alt="Product"
                                    classes="avatar-xs h-100 w-100"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="fs-14 mb-1">
                                  <>{product?.title ?? "-"}</>
                                </h5>
                              </div>
                            </div>
                          </span>
                        </td>
                        <td>
                          {(product?.category as any)?.title ??
                            "Without category"}
                        </td>
                        <td>{formatDate(product?.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        )}
        {selectChoice === "custom" && (
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-end ">
                {totalPages <= 1 ? (
                  ""
                ) : (
                  <Pagination
                    page={page}
                    totalPages={totalPages}
                    handlePagination={handlePages}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        <Modal show={show} onHide={handleClose} size="sm" centered>
          <Modal.Body className="d-flex align-items-center flex-column">
            <h5>{t("modals.are_you_sure")}</h5>
            <p className="text-center text-muted">
              {t(`modals.are_you_sure_complete_workflow`)}
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex align-items-center justify-content-center">
            <Button variant="light" size="sm" onClick={handleClose}>
              {t(`modals.close`)}
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                handleClose();
                completeHandler();
              }}
            >
              {t(`global.complete`)}
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
};

export default WorkflowStep8;
